/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popBindWallet.vue?vue&type=template&id=669f12d8&scoped=true"
import script from "./popBindWallet.vue?vue&type=script&lang=js"
export * from "./popBindWallet.vue?vue&type=script&lang=js"
import style0 from "./popBindWallet.vue?vue&type=style&index=0&id=669f12d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669f12d8",
  null
  
)

export default component.exports